import Tile from './tile';
import Media from './media';

type Arrow = {
  left?: Media;
  right?: Media;
};
export default class Testimonials {
  testimonials: Tile[] | null;
  arrows: Arrow;

  constructor(props: any) {
    this.testimonials =
      props.testimonialsCollection && props.testimonialsCollection.items
        ? props.testimonialsCollection.items.map((s: any) => new Tile(s))
        : null;

    this.arrows = {
      left: props.arrowLeft ? new Media(props.arrowLeft) : undefined,
      right: props.arrowRight ? new Media(props.arrowRight) : undefined
    };
  }
}
